<template>
  <tr>
    <td data-label="User">
      <strong>
        {{ account.dropdownLabel }}
      </strong>
    </td>
    <td data-label="Date Joined">
      {{ account.registeredDate | short_date_format }}
    </td>
    <td data-label="Company">
      {{ account.Company ? account.Company.name : 'N/A' }}
      <br/>
      <template v-if="account.Company && account.Company.legalEntity">
        <b>Legal Entity: </b>{{ account.Company ? account.Company.legalEntity || '' : '' }}
      </template>
    </td>
    <td data-label="E-mail">
      {{ account.email }}
    </td>
    <td data-label="Phone Number">
      {{ account.mobilePhone ? account.mobilePhone : 'N/A' }}
    </td>
    <td data-label="Address">
      {{ account.address ? account.address : 'N/A' }}
    </td>
    <td data-label="Account Holder">
      <span :class="isAccountHolder.class" class="badge">
        {{ isAccountHolder.text }}
      </span>
    </td>
    <td data-label="Account Status">
      <span :class="isActive.class" class="badge">
        {{ isActive.text }}
      </span>
    </td>
    <td data-label="Actions">
      <button class="my-2 btn btn-warning" @click="editClient()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button v-if="!account.deletedAt" class="my-2 btn btn-danger" @click="deleteClient()">
        <i class="fa fa-trash" /> Delete
      </button>
      <button v-else class="my-2 btn btn-info" @click="reinstateClient()">
        <i class="fas fa-undo" /> Reinstate
      </button>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import {
} from '@/vuex/types'
export default {
  name: 'ClientRow',
  props: {
    object: {
      type: Object
    }
  },
  components: {
    DropdownInput
  },
  computed: {
    isAccountHolder () {
      if (this.account.isAccountHolder) {
        return { class: 'badge-success', text: 'Yes' }
      } else {
        return { class: 'badge-danger', text: 'No' }
      }
    },
    isActive () {
      if (!this.account.deletedAt) {
        return { class: 'badge-success', text: 'Active' }
      } else {
        return { class: 'badge-danger', text: 'Deleted' }
      }
    },
    account () {
      return {
        ...this.object
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {
    editClient () {
      this.$emit('edit', { uuid: this.account.uuid })
    },
    deleteClient () {
      this.$emit('deleteObject', { uuid: this.account.uuid })
    },
    reinstateClient () {
      this.$emit('reinstateObject', { uuid: this.account.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/ClientRow.vue